module.exports = __webpack_public_path__ + "static/media/010_done@2x.5621aab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/010_done@2x.png
// module id = 573
// module chunks = 0